export enum LogType {
  'ERROR' = 'error',
  'WARN' = 'warn',
  'LOG' = 'log',
  'INFO' = 'info'
}
